import React from "react";

import MaterialTable from "material-table";
import Grid from "@material-ui/core/Grid";

import { tableIcons } from "../../shared/TableIcons";

import "./StatusTable.css";

export default function StatusTable(props) {
  return (
    <Grid
      item
      xs={12}
      style={{ marginTop: "16px", width: "50vw", margin: "auto" }}
    >
      <MaterialTable
        title={props.title}
        columns={props.columns}
        data={props.data}
        icons={tableIcons}
        localization={{
          body: {
            emptyDataSourceMessage: "Δεν υπάρχουν αρχεία για προβολή.",
            addTooltip: "Προσθήκη",
            deleteTooltip: "Διαγραφή",
            editTooltip: "Επεξεργασία",
            editRow: {
              deleteText:
                "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτήν την διεύθυνση;",
              cancelTooltip: "Ακύρωση",
              saveTooltip: "Αποθήκευση",
            },
          },
          toolbar: {
            searchTooltip: "Αναζήτηση",
            searchPlaceholder: "Αναζήτηση",
          },
          header: {
            actions: "Επεξεργασία/Διαγραφή",
          },

          pagination: {
            firstTooltip: "Πρώτη Σελίδα",
            lastTooltip: "Τελευταία Σελίδα",
            previousTooltip: "Προηγούμενη Σελίδα",
            nextTooltip: "Επόμενη Σελίδα",
            labelDisplayedRows: "{from}-{to} από {count}",
            labelRowsSelect: "Εγγραφές",
          }

        }} options={{ search: false, paging: false }}
      />
    </Grid>
  );
}
